<template>
<div class="map-box">
   <div id="container"></div>
   <i class="icon iconfont icon-fh" @click="goBack"></i>
</div>
</template>

<script>
export default {
  name: "Maps",
  data(){
    return {
      lat:'',
      lng:''
    }

  },
  mounted(){
      // this.getLocation()
      this.getMap()

  },       
  methods: {
    goBack(){
      this.$emit(
        "gotoCom",
        {
          showCom:false
        }
      );
    },
    getLocation() {
      let geolocation = new qq.maps.Geolocation("ANWBZ-FRML5-O7AIX-IX4VR-G6ZBK-JZFCJ", "container");
 
      geolocation.getIpLocation(showPosition, showErr);
 
      function showPosition(position) {
        console.log(position,'------------');
      }

      function showErr() {
        console.log("定位失败");
      }
    },
    getMap(){
      var center = new TMap.LatLng(22.886222,113.481097);    
      var centerHeight = new TMap.LatLng(22.886222,113.481097, 134);
      // 初始化地图
      var map = new TMap.Map('container', {
        zoom: 17, // 设置地图缩放
        center: new TMap.LatLng(22.886222,113.481097), // 设置地图中心点坐标，
        pitch: 0, // 俯仰度
        rotation: 0, // 旋转角度
      });

      // MultiMarker文档地址：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocMarker
      var marker = new TMap.MultiMarker({
        map: map,
        styles: {
          // 点标记样式
          marker: new TMap.MarkerStyle({
            width: 20, // 样式宽
            height: 30, // 样式高
            anchor: { x: 10, y: 30 }, // 描点位置
          }),
        },
        geometries: [
          // 点标记数据数组
          {
            // 标记位置(纬度，经度，高度)
            position: center,
            id: 'marker',
          },
        ],
      });

    },



  },
};
</script>

<style lang="scss" scoped>
#container {
  position: absolute;
  z-index: 999;
  width: 100vw;
  height: 100vh;

}

  .icon {
    position: absolute;
    z-index: 999;
    left:0;
    top:0;
    width:2rem;
    height: 2rem;
    font-size: 2rem;
  }
</style>